// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"style_Breadcrumb__17Olg","content":"style_content__bGwD8"};